import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { capturePreviewPass } from '../api';

/**
 * TICK-081 — a preview pass arrives in the URL exactly once, on *whichever* public page the link
 * points at.
 *
 * This lived inline in `Landing` and nowhere else, so `?preview=` was honoured on `/e/:slug` and
 * silently dropped on `/e/:slug/order/:code` — the page a tester lands on after paying, and the one
 * the server texts them in `orderStatusUrl`. A UAT tester could buy a ticket and then be told
 * "ไม่พบคำสั่งซื้อ" on the confirmation page, because the pass never got a chance to be stored.
 * Sharing one hook is what stops the next public page from forgetting it too.
 *
 * The token is stripped from the URL immediately after it is stored: a bearer token in a location
 * bar gets bookmarked, pasted into chat and sent as a referrer, none of which anyone intended when
 * they clicked "copy link for the team".
 */
export function usePreviewPassCapture(eventSlug?: string): void {
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    if (!params.get('preview')) return;
    capturePreviewPass(window.location.search, eventSlug);
    const next = new URLSearchParams(params);
    next.delete('preview');
    setParams(next, { replace: true });
  }, [params, eventSlug, setParams]);
}
